import React, { useState, useEffect } from "react";
import { useLottie } from "lottie-react";
import groovyWalkAnimation from "./animation.json";

const Won = () => {
  const [showAnimation, setShowAnimation] = useState(true); 

  const options = {
    animationData: groovyWalkAnimation,
    loop: false, 
  };

  const lottieObj = useLottie(options);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowAnimation(false);
    }, 4000); 
    return () => clearTimeout(timer); 
  }, []);

  if (!showAnimation) {
    return null; 
  }

  return (
    <div
      style={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)", 
        zIndex: 9999, 
        width: 600,
        height: 600,
      }}
    >
      {lottieObj.View}
    </div>
  );
};

export default Won;
